import React, { Suspense } from "react";
import { Canvas } from "@react-three/fiber";
import { OrbitControls, useGLTF } from "@react-three/drei";

// Use absolute CloudFront URL
const MODEL_URL = 'https://d22wm4k6mf9kpv.cloudfront.net/models/pump.glb';

console.log('[ModelTest] Preloading model:', MODEL_URL);
useGLTF.preload(MODEL_URL);

// Simple test component to load a single model
function TestModel() {
  console.log('[TestModel] Loading model from:', MODEL_URL);
  
  // useGLTF returns the loaded model synchronously if preloaded
  // or throws a promise if still loading (caught by Suspense)
  const gltf = useGLTF(MODEL_URL);
  console.log('[TestModel] useGLTF result:', gltf);
  
  if (!gltf || !gltf.scene) {
    console.error('[TestModel] No scene in gltf:', gltf);
    return (
      <mesh position={[0, 0, 0]}>
        <boxGeometry args={[1, 1, 1]} />
        <meshStandardMaterial color="red" />
      </mesh>
    );
  }
  
  console.log('[TestModel] Scene loaded successfully, cloning...');
  const clonedScene = gltf.scene.clone();
  console.log('[TestModel] Scene cloned, rendering...');
  
  return (
    <primitive object={clonedScene} position={[0, 0, 0]} scale={0.5} />
  );
}

function LoadingFallback() {
  console.log('[LoadingFallback] Model still loading...');
  return (
    <mesh position={[0, 0, 0]}>
      <boxGeometry args={[1, 1, 1]} />
      <meshStandardMaterial color="yellow" />
    </mesh>
  );
}

export default function ModelTest() {
  console.log('[ModelTest] Component mounted');
  
  return (
    <div style={{ width: '100%', height: '100vh' }}>
      <Canvas camera={{ position: [5, 5, 5], fov: 75 }}>
        <ambientLight intensity={0.6} />
        <directionalLight position={[5, 5, 5]} intensity={0.5} />
        <OrbitControls />
        <Suspense fallback={<LoadingFallback />}>
          <TestModel />
        </Suspense>
      </Canvas>
      <div style={{ position: 'absolute', top: 10, left: 10, color: 'white', background: 'black', padding: 10, zIndex: 100 }}>
        <h3>Model Loading Test</h3>
        <p>URL: {MODEL_URL}</p>
        <p>Check console for [TestModel] logs</p>
        <p>🟡 Yellow box = Loading...</p>
        <p>🔴 Red box = No scene in gltf</p>
        <p>✅ 3D model = Success!</p>
      </div>
    </div>
  );
}
